import DashboardLayout from "../common/pages/layout/nav/DashboardLayoutSlim";

/**
 * This file controls the routing of the CAP app.
 * First, components in the app are imported using a lazy-loading paradigm with webpack (https://router.vuejs.org/guide/advanced/lazy-loading.html)
 * Second, components are assigned to URL paths, usually with some user-role authorization criterion
 * Third, this information is exported for usage in Vue Router in another file
 *
 * Note that when grouping components into page objects, typically the parent component is an overlay (layout/dashboard).
 * This overlay will display the child components in a router-view window.
 * Attempting to circumnavigate this process may lead to router failure if you don't know what you're doing.
 *
 * @author Andrew Gunter
 */

//Overlay Components (Layouts/Dashboards)
const StandaloneLayout = () => import(/* webpackChunkName: "PurchaserChunk" */'src/common/pages/layout/StandaloneLayout.vue');
const BrokerDashboard = () => import(/* webpackChunkName: "BrokerChunk" */  'src/broker/BrokerDashboard.vue');
const DeveloperDashboard = () => import(/* webpackChunkName: "DeveloperChunk" */ 'src/developer/DeveloperDashboard.vue');
const LenderDashboard = () => import(/* webpackChunkName: "LenderChunk" */'src/lender/LenderDashboard.vue');
const PurchaserDashboard = () => import(/* webpackChunkName: "PurchaserChunk" */'src/purchaser/PurchaserDashboard.vue');
const PartnerDashboard = () => import(/* webpackChunkName: "PartnerChunk" */'src/partner/PartnerDashboard.vue');
const AdminDashboard = () => import(/* webpackChunkName: "AdminChunk" */ 'src/administration/AdminDashboard.vue');
const OciDashboard = ()=>import(/* webpackChunkName: "OciChunk" */ 'src/oci-internal/OciDashboard.vue');

//Oci operations
const OciDashboardManagement = () => import(/* webpackChunkName: "OciChunk" */'../oci-internal/Analytics.vue');
const OciClients = () => import(/* webpackChunkName: "OciChunk" */'../oci-internal/Clients.vue');
const OciUAD = () => import(/* webpackChunkName: "OciChunk" */'../oci-internal/OciUAD.vue');

// GeneralViews
const NotFound = () => import(/* webpackChunkName: "RootChunk" */ 'src/common/pages/general/NotFoundPage.vue');

// Page Headers
const DefaultHeader = () => import(/* webpackChunkName: "RootChunk" */ 'src/reference/pages/Dashboard/DefaultHeader');

//Authentication and Authorization
const AuthenticationLayout = ()=>  import(/* webpackChunkName: "LoginChunk" */ 'src/common/pages/auth/AuthenticationLayout.vue');
const Login = ()=>  import(/* webpackChunkName: "LoginChunk" */ 'src/common/pages/auth/Login.vue');
const ForgotPassword = ()=>  import(/* webpackChunkName: "LoginChunk" */ 'src/common/pages/auth/ForgotPassword.vue');
const ResetPassword = ()=>  import(/* webpackChunkName: "LoginChunk" */ 'src/common/pages/auth/ResetPassword.vue');
const ResetCancel = ()=>  import(/* webpackChunkName: "LoginChunk" */ 'src/common/pages/auth/ResetCancel.vue');
const NotAuthorized = ()=> import(/* webpackChunkName: "RootChunk" */ 'src/common/pages/auth/NotAuthorized.vue');
//NOT CURRENTLY IN USE. POSSIBLY NEEDED IN FUTURE
//const Lock = ()=>  import(/* webpackChunkName: "RootChunk" */ 'src/common/pages/auth/Lock.vue');
//const Register = ()=>  import(/* webpackChunkName: "LoginChunk" */ 'src/common/pages/auth/Register.vue');
//const NeedHelp = ()=>  import(/* webpackChunkName: "LoginChunk" */ 'src/common/pages/auth/NeedHelp.vue');

// OCI Developer pages
const ProgramPerformance = () => import(/* webpackChunkName: "DeveloperChunk" */ 'src/developer/pages/ProgramPerformance.vue');
const MarketingCommunication = () => import(/* webpackChunkName: "DeveloperChunk" */ 'src/developer/pages/MarketingCommunication.vue');
const ProgramAdministration = () => import(/* webpackChunkName: "DeveloperChunk" */ 'src/developer/pages/ProgramAdministration.vue');
const marketing = () => import(/* webpackChunkName: "DeveloperChunk" */ 'src/developer/pages/Marketing.vue');
const DeveloperProfile = ()=>  import(/* webpackChunkName: "DeveloperChunk" */ 'src/common/pages/userprofile/UserProfile.vue');

// OCI Purchaser pages
const PurchaserWizard = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/PurchaserWizardPilot.vue');/*version with array with only personal Info*/
const TermsOfService = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/TermsOfService.vue');
const PurchaserProfile = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/PurchaserProfile.vue');/*version with array wiyh only personal Info*/
const PurchaserApp= () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/purchaserdemo/PurchaserApp.vue');
const PurchaserSurvey= () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/purchaserdemo/PurchaserSurvey.vue');
const PurchaserFlowManager= () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/PurchaserFlowManager.vue');

//The following purchaser pages are not currently in use. Leave however for future development or refactoring
//const MailingCoBrand = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/MailingCoBrand.vue');
//const MortgageExplorer = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/MortgageExplorer.vue');
//const MortgageExplorerEmp = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/MortgageExplorerEmp.vue');
//const MortgageExplorerEqBank = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/MortgageExplorerEqBank.vue');
//const FundingAccelerator = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/FundingAccelerator.vue');
//const PurchaserAuthentication = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/PurchaserAuthentication.vue');
//const PurchaserSignup = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/PurchaserSignup.vue');
//const OcApplication = () => import(/* webpackChunkName: "PurchaserChunk" */ 'src/purchaser/pages/OcApplication.vue');


// OCI Lender Pages
const LenderProgramPerformance = () => import(/* webpackChunkName: "LenderChunk" */ 'src/lender/pages/ProgramPerformance.vue');
const LenderProgramGovernance = () => import(/* webpackChunkName: "LenderChunk" */ 'src/lender/pages/ProgramGovernance.vue');
const LenderProfile = ()=>  import(/* webpackChunkName: "LenderChunk" */ 'src/common/pages/userprofile/UserProfile.vue');
const DealActivity = ()=> import(/* webpackChunkName: "LenderChunk" */ 'src/lender/pages/DealActivity.vue');
const LenderClientTable = () => import(/* webpackChunkName: "LenderChunk" */ 'src/lender/pages/LenderPage.vue');
const LenderUserActivityDetails = () => import(/* webpackChunkName: "LenderChunk" */'src/lender/components/LenderUAD/LenderUserActivityDetails.vue');
const LenderUserActivityDetailsWrapper = () => import(/* webpackChunkName: "LenderChunk" */'src/lender/components/LenderUAD/LenderUserActivityDetailsWrapper.vue');
const LenderMortgageApp = () => import(/* webpackChunkName: "LenderChunk" */'src/lender/components/LenderMortgageApp.vue');

//OCI Partner Pages
const PartnerProgramPerformance = () => import(/* webpackChunkName: "PartnerChunk" */ 'src/partner/PartnerProgramPerformance.vue');
const PartnerProfile = () => import(/* webpackChunkName: "PartnerChunk" */ 'src/common/pages/userprofile/UserProfile.vue')
const Invoicing = () => import('src/partner/pages/accounting/Invoicing.vue');
const Accounting = () => import('src/partner/pages/accounting/AccountingInvoiceManagement.vue');

// OCI Broker Pages
const BrokerPage = ()=> import(/* webpackChunkName: "BrokerChunk" */ 'src/broker/BrokerPage.vue');
const MortgageApp = () => import(/* webpackChunkName: "BrokerChunk" */ 'src/broker/MortgageApp.vue');
const BrokerProfile = ()=>  import(/* webpackChunkName: "BrokerChunk" */ 'src/common/pages/userprofile/UserProfile.vue');
const Documents = ()=> import(/* webpackChunkName: "BrokerChunk" */ 'src/common/pages/general/Documents.vue');
const ConditionsManagement = () => import(/* webpackChunkName: "BrokerChunk" */ 'src/broker/ConditionsManagement.vue');
const Conditions = () => import(/* webpackChunkName: "BrokerChunk" */ 'src/broker/Conditions.vue');
const UserActivityDetails = () => import(/* webpackChunkName: "BrokerChunk" */ 'src/broker/UserActivityDetails.vue');
const UserActivityDetailsWrapper = () => import(/* webpackChunkName: "BrokerChunk" */ 'src/broker/UserActivityDetailsWrapper.vue');


//Chat Components
const BrokerChat = () => import(/* webpackChunkName: "BrokerChunk" */ 'src/broker/BrokerChat.vue');

// OCI Admin Pages
const AdminProgram = ()=>import(/* webpackChunkName: "AdminChunk" */ 'src/administration/pages/AdminProgram.vue');
const AdminFirmAndRep = ()=>import(/* webpackChunkName: "AdminChunk" */ 'src/administration/pages/AdminFirmAndRep.vue');
const AdminPlatform = ()=>import(/* webpackChunkName: "AdminChunk" */ 'src/administration/pages/AdminPlatform.vue');
const CampaignManagement = ()=>import(/* webpackChunkName: "AdminChunk" */ 'src/administration/pages/CampaignManagement.vue');
const AdminProfile = ()=>  import(/* webpackChunkName: "AdminChunk" */ 'src/common/pages/userprofile/UserProfile.vue');
const PurchaserJourneyAdmin= () => import(/* webpackChunkName: "AdminChunk" */ 'src/purchaser/pages/purchaserdemo/PurchaserJourneyAdmin.vue');
const SurveyAdmin= () => import(/* webpackChunkName: "AdminChunk" */ 'src/purchaser/pages/purchaserdemo/SurveyAdmin.vue');





/* Not used since we are moving to using our own login ui and not cognito. Leave still if revert necessary
let userAuthenticate = {
  path: '/authenticate',
  name: 'Authenticate',
  meta: {
    requiresAuth: false,
  },
  component: Authenticate,
}
let userAuthenticated= {
  path: '/authenticated',
  name: 'Authenticated',
  meta: {
    requiresAuth: false,
  },
  component: Authenticated,

}
*/

let notAuthorized= {
  path: '/unauthorized',
  name: 'NotAuthorized',
  meta: {
    requiresAuth: false,
  },
  component: NotAuthorized,

};
/* Not currently in use, review and refactoring needed
let standalonePages = {
  path: '/',
  component: StandaloneLayout,
  name: '',
  meta: {
    requiresAuth: true,
    permissions:['super','oci','purchaser','applicant']
  },
  children: [
    {
      path: 'explore',
      name: 'Mortgage Explorer',
      components: {default: MortgageExplorer, header: DefaultHeader}
    },
    {
      path: 'cobrand',
      name: 'Co-Brand',
      components: {default: MailingCoBrand, header: DefaultHeader},

    }
  ]
};*/

let authPages = {
  path: '/auth',
  redirect: '/auth/login',
  component:   AuthenticationLayout,
  name: 'Auth',
  meta: {
    requiresAuth: false,
  },
  children: [
    {
      path: 'login',
      name: 'Login',
      component: Login
    },
    {
      path: 'reset',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: 'reset/cancel',
      name: 'ResetCancel',
      component: ResetCancel
    },
    {
      path: 'forgot',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    /*  NOT CURRENTLY IN USE. POSSIBLY NEEDED IN FUTURE
    {
        path: 'register',
        name: 'Register',
        component: Register
      },
      {
        path: 'lock',
        name: 'Lock',
        component: Lock
      },
      {
        path: 'needhelp',
        name: 'NeedHelp',
        component: NeedHelp
      },*/
  ]
};

let purchaserPages = {
  path: '/purchaser',
  component: PurchaserDashboard,
  /* TODO:thinking we want to redirect /purchaser by default to a 404 */
  redirect: '/purchaser/termsofservice',
  name: 'Purchaser'
  ,
  children: [
    {
      path: 'purchaserwizard',
      name: 'PurchaserWizard',
      components: {default: PurchaserWizard, header: DefaultHeader}
    },


    {
      path: 'termsofservice',
      name: 'TermsOfService',
      components: {default: TermsOfService, header: DefaultHeader}
    },
    {
      path: 'purchaserprofile',
      name: 'PurchaserProfile',
      components: {default: PurchaserProfile, header: DefaultHeader}
    },
    {
      path: 'app',
      name: 'PurchaserApp',
      components: {default: PurchaserApp, header: DefaultHeader}
    },
        {
      path: 'flow',
      name: 'PurchaserFlowManager',
      components: {default: PurchaserFlowManager, header: DefaultHeader}
    },
    {
      path: 'survey',
      name:"PurchaserSurvey",
      components: {default: PurchaserSurvey, header: DefaultHeader}

    }


    //The following purchaser pages are not currently in use. Leave however for future development or refactoring
    /*{
      path: 'explorer',
      name: 'explorer',
      components: {default: MortgageExplorer, header: DefaultHeader},
    },
    {
      path: 'cobrand',
      name: 'co-brand',
      components: {default: MailingCoBrand, header: DefaultHeader},

    },

    {
      path: 'purchaserauth',
      name: 'PurchaserAuthentication',
      components: {default: PurchaserAuthentication, header: DefaultHeader}
    },
    {
      path: 'purchasersignup',
      name: 'PurchaserSignup',
      components: {default: PurchaserSignup, header: DefaultHeader}
    },
    {
      path: 'ocapplication',
      name: 'OcApplication',
      components: {default: OcApplication, header: DefaultHeader}
    },
    {
      path: 'exploreremp',
      name: 'MortgageExplorerEmp',
      components: {default: MortgageExplorerEmp, header: DefaultHeader}
    },

    {
      path: 'explorerEq',
      name: 'MortgageExplorerEqBank',
      components: {default: MortgageExplorerEqBank, header: DefaultHeader}
    },

    {
      path: 'accelerator',
      name: 'FundingAccelerator',
      components: {default: FundingAccelerator, header: DefaultHeader}
    },*/
  ]
};
let ociInternal = {
  path: '/oci',
  component: OciDashboard,
  redirect: '/oci/dashboard',
  name: 'OCI',
  meta: {
    requiresAuth: true,
    permissions:['super','oci_finance_director']
  },
  children: [
    {
      path: 'analytics',
      name: 'OCI Dashboard',
      components: {default: OciDashboardManagement, header: DefaultHeader}
    },
    {
      path: 'uad',
      name: 'UAD',
      components: {default: OciUAD, header: DefaultHeader}
    },
    {
      path: 'clients',
      name: 'Clients',
      components: {default: OciClients, header: DefaultHeader}
    },
  ]
};

let brokerPages = {
  path: '/broker',
  component: BrokerDashboard,
  redirect: '/broker/brokerpage',
  name: 'Broker',
  meta: {
    requiresAuth: true,
    permissions:['super','oci_broker']
  },
  children: [
    {
      path: 'conditionsManagement',
      name: 'Conditions Management',
      components: {default: ConditionsManagement, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super','oci_broker']
      },
    },
    {
      path: 'conditions',
      name: 'conditions',
      components: {default: Conditions, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super','oci_broker']
      },
    },
    {
      path: 'profile',
      name: 'Broker Profile',
      components: {
        default: BrokerProfile,
        header: DefaultHeader,
      }
    },
    {
      path: 'brokerpage',
      name: 'BrokerPage',
      components: {default: BrokerPage, header: DefaultHeader},
    },
    {
      path: 'mortgageapp',
      name: 'MortgageApp',
      components: {default: MortgageApp, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super','oci_broker']
      },
    },
    {
      path: 'chat',
      name: 'BrokerChat',
      components: {default: BrokerChat, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super','oci_broker']
      },
    },
    {
      path: 'UserActivityDetailsWrapper',
      name: 'User Activity Details Wrapper',
      components: {default: UserActivityDetailsWrapper, header: DefaultHeader},
      props: true,
      meta: {
        requiresAuth: true,
        permissions:['super','oci_broker']
      }
    },
    {
      path: '/UserActivityDetails',
      name: 'User Activity Details',
      components: {default: UserActivityDetails, header: DefaultHeader},
      props: true,
      meta: {
        requiresAuth: true,
        permissions:['super','oci_broker']
      }
    },
    {
      path: 'documents',
      name: 'Generic Documents',
      components: {default: Documents, header: DefaultHeader}
    },
  ]
};

let adminPages = {
  path: '/admin',
  component: AdminDashboard,
  name: 'OneClose Admin',
  meta: {
    //requiresAuth: false,
   // permissions:['super']
  },
  children: [
    {
      path: 'profile',
      name: 'Admin Profile',
      components: {
        default: AdminProfile,
        header: DefaultHeader,
      }
    },
    {
      path: 'program',
      name: 'AdminProgram',
      components: {default: AdminProgram, header: DefaultHeader},
    },
    {
      path: 'firmrep',
      name: 'AdminFirmAndRep',
      components: {default: AdminFirmAndRep, header: DefaultHeader},
    },
    {
      path: 'platform',
      name: 'AdminPlatform',
      components: {default: AdminPlatform, header: DefaultHeader},
    },
    {
      path: 'campaignManagement',
      name: 'CampaignManagement',
      components: {default: CampaignManagement, header: DefaultHeader},
    },
    {
      path: 'purchaser',
      name: 'PurchaserJourneyAdmin',
      components: {default: PurchaserJourneyAdmin, header: DefaultHeader}
    },

    { path: 'survey',
      name: 'SurveyAdmin',
      components: {default: SurveyAdmin, header: DefaultHeader}
    }
  ]
};

let lenderPages = {
  path: '/lender',
  component: LenderDashboard,
  redirect: '/lender/program_performance',
  name: 'Lender',
  meta: {
    requiresAuth: true,
    permissions:['super','lender']
  },
  children: [
    {
      path: 'profile',
      name: 'Lender Profile',
      components: {
        default: LenderProfile,
        header: DefaultHeader,
      }
    },
    {
      path: 'program_performance',
      name: 'Lender Program Performance',
      components: {default: LenderProgramPerformance, header: DefaultHeader},
    },
    {
      path: 'lenderClientTable',
      name: 'Lender Client Management',
      components: {default: LenderClientTable, header: DefaultHeader},
    },
    {
      path: 'program_governance',
      name: 'Program Governance',
      components: {default: LenderProgramGovernance, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super','lender_manager']
      }
    },
    {
      path: 'lender_UAD',
      name: 'Lender User Activity Details Wrapper',
      props:true,
      components: {default: LenderUserActivityDetailsWrapper, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super','lender_manager']
      }
    },
    {
      path: 'lenderMtgApp',
      name: 'Lender Mortgage App',
      props:true,
      components: {default: LenderMortgageApp, header: DefaultHeader},
    },

  ]
};

let partnerPages = {
  path: '/partner',
  component: PartnerDashboard,
  redirect: '/partner/program_performance',
  name: 'Partner',
  meta: {
    requiresAuth: true,
    permissions:['super','partner','oci_broker_manager']
  },
  children: [
    {
      path: 'profile',
      name: 'Partner Profile',
      components: {
        default: PartnerProfile,
        header: DefaultHeader,
      }
    },
    {
      path: 'program_performance',
      name: 'Partner Program Performance',
      components: {default: PartnerProgramPerformance, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super','partner','oci_broker_manager']
      }
    },
    {
      path: 'invoicing',
      name: 'Invoicing',
      components: {default: Invoicing, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super']
      }
    },
    {
      path: 'accounting',
      name: 'Accounting',
      components: {default: Accounting, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super']
      }
    }
  ]
};

let developerPages = {
  path: '/developer',
  component: DeveloperDashboard,
  redirect: '/developer/ProgramPerformance',
  name: 'Developer',
  meta: {
    requiresAuth: true,
    permissions:['super', 'developer'],
  },
  children: [
    {
      path: 'profile',
      name: 'Developer Profile',
      components: {
        default: DeveloperProfile,
        header: DefaultHeader,
      }
    },
    {
      path: 'ProgramPerformance',
      name: 'Program Performance',
      components: {default: ProgramPerformance, header: DefaultHeader},
    },
    {
      path: 'MarketingCommunication',
      name: 'Marketing Communication',
      components: {default: MarketingCommunication, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super', 'developer_marketer'],
      }
    },
    {
      path: 'ProgramAdministration',
      name: 'Program Administration',
      components: {default: ProgramAdministration, header: DefaultHeader},
      meta: {
        requiresAuth: true,
        permissions:['super', 'developer_admin'],
      }
    },
  ]
};

const routes = [
  {
    path: '/',
    redirect: '/auth/login',
    meta: {
      requiresAuth: false,
    },
    name: 'Home',
  },
  {
    path: '/dashboard',
    redirect: '/auth/login',
    name: 'Home-Dashboard',
    meta: {
      requiresAuth: false,
    },
  },
  adminPages,
  purchaserPages,
  //standalonePages, currently not in use
  lenderPages,
  brokerPages,
  partnerPages,
  notAuthorized,
  developerPages,
  authPages,
  ociInternal,
  {path: '*', component: NotFound}
];

export default routes

